export default theme => ({
  root: {
    width: 600,
    '& .MuiFormControl-root': {
      marginTop: 0,
      marginBottom: theme.spacing(2)
    }
  },
  actions: {
    marginTop: theme.spacing(4),
    '& .MuiButton-root:first-child': {
      marginRight: theme.spacing(2)
    }
  },
  right: {
    float: 'right',
    marginLeft: 15
  },
  tabContent: {
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.divider,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  }
});
